import { EyeOff } from "lucide-react";
import { inUse, type MaterialRow } from "./meta";

/*
 * How an item's state shows wherever it's listed (the Items tab, a bundle's contents, a group's items), the same everywhere:
 * hidden (states.ts: archived in ServiceM8, on standby) as an eye before its name, retired (archived) as its name greyed
 * and struck through.
 */

/** Before a hidden item's name: an eye, struck through (its meaning on hover). */
export function HiddenMark({ item }: Readonly<{ item: Pick<MaterialRow, "hidden"> }>) {
    return item.hidden ? (
        <span className="inline-flex shrink-0" title="Hidden: not offered on jobs (archived in ServiceM8), kept priced here, ready to unhide.">
            <EyeOff className="size-3.5 text-muted" aria-label="Hidden" />
        </span>
    ) : null;
}

/** A retired (archived) item's name: greyed and struck through. */
export const retiredName = (item: Pick<MaterialRow, "active" | "hidden">) => (inUse(item) ? undefined : "text-muted line-through");
